import { Container, Row, Col, Button } from "react-bootstrap";

export default function Page404() {
  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center vh-100 bg-light"
    >
      <Row className="text-center">
        <Col>
          <h1 className="display-1 fw-bold text-secondary">404</h1>
          <h2 className="mb-3">Page Not Found</h2>
          <p className="text-muted mb-4">
            Oops! The page you’re looking for doesn’t exist or has been moved.
          </p>
          <Button
            variant="link"
            size="sm"
            onClick={() => (window.location.href = "/")}
          >
            Go Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
